import React from 'react';
import { string, node } from 'prop-types';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';

import styles from './styles';

const ConfigurationField = ({ title, description, children, style, Icon, iconColor }) => (
  <div style={[style, styles.container]}>
    <div style={styles.description}>
      <div style={styles.iconAndTitleContainer}>
        {appConfig.userDataManagement.rowDescIcons && (
          <div style={styles.icons}>{Icon && <Icon color={iconColor} />}</div>
        )}
        <UTLabel semibold>{title}</UTLabel>
      </div>
      {description && (
        <UTLabel darkGray small>
          {description}
        </UTLabel>
      )}
    </div>
    {children}
  </div>
);

ConfigurationField.propTypes = {
  title: string.isRequired,
  description: string,
  Icon: node,
  iconColor: string
};

export default Radium(ConfigurationField);
